export const SYMPTOMS_LIST_QUESTION = "select_symptoms";

/** A waitlist question whose name starts with this is the quiz's final contact form, not an exit. */
export const COMPLETION_WAITLIST_PREFIX = "enter_you_information";

/** Schema page-name prefixes the quiz components key their behavior on. */
export const WAITLIST_PAGE_PREFIX = "waitlist_";
export const RETURN_TO_HOME_PAGE_PREFIX = "return_to_home";

/** Survey page that still uses the waitlist prefix but should follow return-to-home exclusion routing (WEB-3119). */
export const LEGACY_RETURN_TO_HOME_WAITLIST_PAGE = "waitlist_oestra_safety";

/** Waitlist multipletext on return-to-home exclusion pages that should post before redirect. */
export const RETURN_TO_HOME_WAITLIST_SUBMIT_QUESTIONS = [
    "not_the_right_time",
] as const;

export const QUIZ_LOG_EVENT = {
    WAITLIST_SUBMIT_FAILED: "Quiz waitlist submit failed",
    BIOIDENTICAL_COMPLETION_TRACKING_FAILED: "Bioidentical completion tracking failed",
} as const;

/**
 * Waitlist question names for the DS quiz variants (`componentsDS/Quiz` and
 * `componentsDS/QuizRedesign`). Named distinctly from the legacy quiz's own
 * (shorter) `WAIT_LIST_QUESTIONS` array — the two lists intentionally differ
 * (the legacy one omits `not_the_right_time`), so they must not share an
 * identifier.
 */
export const DS_WAITLIST_QUESTIONS = [
    "start_after_porstpartum_waitlist",
    "the_minimum_age_to_begin_waitlist",
    "we_do_not_currently_subscribe_waitlist",
    "enter_you_information",
    "enter_you_information_2",
    "waitlist_under_21",
    "wait_until_postpartum",
    "final_step",
    "not_the_right_time",
];
